import { CanvasRenderingTarget2D } from 'fancy-canvas'
import { Coordinate, ISeriesPrimitivePaneRenderer } from 'lightweight-charts'
import DrawingBase from './drawing.base'
import { HANDLER_RADIUS, HANDLER_STROKE_WIDTH } from './drawing.constants'
import { scaledCoordinate } from './drawing.helper'
import { primaryDrawingColor, white } from '../../../assets/colors'


export type DrawingHandlePaneRendererOptions = {
    id: string,
    drawing: DrawingBase<any, any, any>
}

class DrawingHandlePaneRenderer implements ISeriesPrimitivePaneRenderer {
    drawing: DrawingBase<any, any, any>
    // keeping only id so that it need not be updated on every change, and can be fetched on demand.
    id: string

    constructor(options: DrawingHandlePaneRendererOptions) {
        this.drawing = options.drawing
        this.id = options.id
    }

    draw(target: CanvasRenderingTarget2D) {
        target.useBitmapCoordinateSpace(scope => {
            const horizontalPixelRatio = scope.horizontalPixelRatio
            const verticalPixelRatio = scope.verticalPixelRatio
            const point = this.drawing.getHandlePoint(this.id)
            if (!point) return null

            let x = this.drawing.timeToCoordinate(point.x)
            let y = this.drawing.priceToCoordinate(point.y)
            const coordinates = point.coordinates
            if (coordinates) {
                x = coordinates.x as Coordinate
                y = coordinates.y as Coordinate
            }
            if (!x || !y) return

            x = scaledCoordinate(x, horizontalPixelRatio) as Coordinate
            y = scaledCoordinate(y, verticalPixelRatio) as Coordinate
            const ctx = scope.context
            ctx.beginPath()
            ctx.strokeStyle = primaryDrawingColor
            ctx.fillStyle = white
            ctx.lineWidth = HANDLER_STROKE_WIDTH * window.devicePixelRatio
            ctx.arc(x, y, HANDLER_RADIUS * window.devicePixelRatio, 0, 2 * Math.PI)
            ctx.fill()
            ctx.stroke()
        })
    }
}


export default DrawingHandlePaneRenderer